import UserActions from '../../actions/UserActions';

class GLRegister extends React.Component {

    constructor(props) {
        super(props);

        this.selectRegister = this.selectRegister.bind(this);
    }

    selectRegister(register) {
        UserActions.selectRegister(register);
        this.props.onSelect();
    }

    render() {
        var self             = this;
        var page             = this.props.page;
        var registers        = this.props.registers;
        var selectedLocation = this.props.selectedLocation;
        var selectedRegister = this.props.selectedRegister;

        if (page !== 'register')
            return null;

        if(!registers || registers.length === 0) {
            return <div className='gl-location'></div>;
        }

        return (
            <div className='gl-location'>

                <div className='container gl-location__container'>
                    <div className='gl-location__contents'>
                        <div className='row'>
                            <div className='col-12'>
                                <div className='profile-main__container--header'>
                                    Select Register
                                </div>
                            </div>
                        </div>
                        <div className='gl-location__list'>
                        { registers && registers.map((register, i) => {
                            return (
                                <div
                                    className='gl-location__row'
                                    key={register.id}>

                                    <div className='gl-location__row--title'>
                                        {register.TerminalName}
                                    </div>

                                    <div
                                        className='gl-location__row--select'
                                        onClick={ self.selectRegister.bind(self, register) }>

                                        { selectedRegister.id === register.id ? 'SELECTED' : 'SELECT' }
                                    </div>
                                </div>
                            );
                        })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default GLRegister;


// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/GLRegister.react.jsx